import { render, staticRenderFns } from "./ListaTavolo.vue?vue&type=template&id=5a03fb18&scoped=true&"
import script from "./ListaTavolo.vue?vue&type=script&lang=js&"
export * from "./ListaTavolo.vue?vue&type=script&lang=js&"
import style0 from "./ListaTavolo.vue?vue&type=style&index=0&id=5a03fb18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a03fb18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a03fb18')) {
      api.createRecord('5a03fb18', component.options)
    } else {
      api.reload('5a03fb18', component.options)
    }
    module.hot.accept("./ListaTavolo.vue?vue&type=template&id=5a03fb18&scoped=true&", function () {
      api.rerender('5a03fb18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ListaTavolo.vue"
export default component.exports